import "./OpeningHours.scss";
import moment from "moment";
import { v4 as uuid } from "uuid";
import _ from "lodash";
import InfoDialog from "@/components/Common/InfoDialog/InfoDialog.vue";
import DateInput from "@/components/Common/DateInput/DateInput.vue";
import POIStep from "@/components/POI/POIStep/POIStep.vue";
import { stateItemsAll, stateItems } from "@/configuration/formConfigurations";
import { states } from "@/helpers/holidaysHelper";
import { dateFormat } from "@/helpers/eventHelper";

const allWeekDays = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday"
];
const defaultWeekdays = [
  { active: false, times: [{}], dayOfWeek: "Monday" },
  { active: false, times: [{}], dayOfWeek: "Tuesday" },
  { active: false, times: [{}], dayOfWeek: "Wednesday" },
  { active: false, times: [{}], dayOfWeek: "Thursday" },
  { active: false, times: [{}], dayOfWeek: "Friday" },
  { active: false, times: [{}], dayOfWeek: "Saturday" },
  { active: false, times: [{}], dayOfWeek: "Sunday" }
];

moment.updateLocale("de", {
  week: {
    dow: 1
  }
});

export default {
  name: "OpeningHours",
  props: ["editedItem", "step", "position", "isOwnedBySubPrincipal"],
  components: { InfoDialog, POIStep, DateInput },
  data: () => ({
    editorUrl: "https://cdn.eberl-online.cloud/ckeditor5/ckeditor5.js",
    seasonFrom: false,
    seasonUntil: false,
    closedFrom: false,
    closedUntil: false,
    tab: "",
    swTab: "",
    panels: 1,
    dialog: false,
    delWeek: {},
    tabs: ["Woche", "Saison Wochen", "Geschlossen", "Aktionstage/Feiertage"],
    weekDays: moment.weekdays(true),
    showHolidaySelector: false,
    selectedState: "",
    selectedYear: "",
    holidaysForSeasonal: [],
    vacationsForSeasonal: [],
    holidaysForClosed: [],
    vacationsForClosed: [],
    holidaysForSpecial: [],
    vacationsForSpecial: [],
    states: states,
    stateItemsAll
  }),
  mounted() {
    this.fixData();
  },
  methods: {
    addNewWeek(week) {
      const newWeek = week
        ? _.cloneDeep({ ...week })
        : {
            weekdays: _.cloneDeep(defaultWeekdays)
          };
      newWeek.id = uuid();
      this.editedItem.openingHours.seasonalOpeningHours.push(newWeek);
    },
    deleteSeasonWeek(week) {
      this.editedItem.openingHours.seasonalOpeningHours.splice(
        this.editedItem.openingHours.seasonalOpeningHours.indexOf(week),
        1
      );
      this.dialog = false;
    },
    addNewClosed() {
      this.editedItem.openingHours.closedDays.push({});
    },
    deleteClosed(index) {
      this.editedItem.openingHours.closedDays.splice(index, 1);
      this.dialog = false;
    },
    addNewSpecial() {
      this.editedItem.openingHours.specialDays.push({});
    },
    deleteSpecial(index) {
      this.editedItem.openingHours.specialDays.splice(index, 1);
      this.dialog = false;
    },
    prepareDelDialog(week) {
      this.delWeek = week;
      this.dialog = true;
    },
    changeStep(position) {
      this.$emit("changeStep", position);
    },
    addTimesObject(dayIndex) {
      if (!this.editedItem.openingHours.weekdays[dayIndex]?.times)
        this.editedItem.openingHours.weekdays[dayIndex].times = [];

      this.editedItem.openingHours.weekdays[dayIndex].times.push({
        from: "",
        to: "",
        note: ""
      });
    },
    removeTimesObject(dayIndex, timeIndex) {
      this.editedItem?.openingHours?.weekdays?.[dayIndex]?.times?.splice(
        timeIndex,
        1
      );
    },
    getTimesArray(openingHours, dayIndex) {
      return openingHours?.weekdays?.[dayIndex]?.times ?? [];
    },
    fixData() {
      const { openingHours } = this.editedItem;
      let { weekdays, seasonalOpeningHours } = openingHours;
      if (!weekdays || (weekdays && !weekdays.length))
        openingHours.weekdays = _.cloneDeep(defaultWeekdays);
      else this.setWeekDays();
      if (seasonalOpeningHours?.length)
        seasonalOpeningHours.forEach(oh => {
          if (!oh.weekdays || (oh.weekdays && !oh.weekdays.length))
            oh.weekdays = _.cloneDeep(defaultWeekdays);
        });
    },
    setWeekDays() {
      this.editedItem.openingHours.weekdays.forEach((weekday, index) => {
        if (weekday)
          this.editedItem.openingHours.weekdays[index].dayOfWeek =
            allWeekDays[index];
      });
    },
    setTimesArray(isChecked, dayIndex) {
      if (!this.editedItem._id) this.$forceUpdate();
      if (
        (isChecked &&
          !this.editedItem?.openingHours?.weekdays?.[dayIndex]?.times
            ?.length) ||
        !isChecked
      ) {
        this.editedItem.openingHours.weekdays[dayIndex].times = [{}];
      }
    },
    async getHolidays() {
      if (this.selectedState && this.selectedYear) {
        try {
          const payload = {
            state: this.selectedState,
            year: this.selectedYear
          };
          await Promise.all([
            await this.$store.dispatch("getHolidays", payload),
            await this.$store.dispatch("getVacations", payload)
          ]);
        } catch (error) {
          await this.$store.dispatch("createError", error);
        }
      }
    },
    addHolidaysToSeasonalWeeks() {
      const weeksToAdd = this.holidaysForSeasonal.concat(
        this.vacationsForSeasonal
      );
      weeksToAdd.forEach(weekId => {
        const week =
          this.holidays.find(holiday => holiday.id === weekId) ||
          this.vacations.find(vacation => vacation.id === weekId);

        const newWeek = {
          note: week.name[0].text,
          startDate: `${week.startDate}T00:00:00.000Z`,
          endDate: `${week.endDate}T00:00:00.000Z`,
          weekdays: _.cloneDeep(defaultWeekdays)
        };
        this.addNewWeek(newWeek);
      });
    },
    addHolidaysToClosedWeeks() {
      const weeksToAdd = this.holidaysForClosed.concat(this.vacationsForClosed);
      weeksToAdd.forEach(weekId => {
        const week =
          this.holidays.find(holiday => holiday.id === weekId) ||
          this.vacations.find(vacation => vacation.id === weekId);

        const newWeek = {
          note: week.name[0].text,
          startDate: `${week.startDate}T00:00:00.000Z`,
          endDate: `${week.endDate}T00:00:00.000Z`
        };
        this.editedItem.openingHours.closedDays.push(newWeek);
      });
    },
    addHolidaysToSpecialWeeks() {
      const weeksToAdd = this.holidaysForSpecial.concat(
        this.vacationsForSpecial
      );
      weeksToAdd.forEach(weekId => {
        const week =
          this.holidays.find(holiday => holiday.id === weekId) ||
          this.vacations.find(vacation => vacation.id === weekId);

        const newWeek = {
          note: week.name[0].text,
          date: `${week.startDate}T00:00:00.000Z`
        };
        this.editedItem.openingHours.specialDays.push(newWeek);
      });
    },
    dateFormat
  },
  computed: {
    freeAccess: {
      get() {
        if (this.editedItem.openingHours.freeAccess === null)
          return "notSpecified";
        else return this.editedItem.openingHours.freeAccess;
      },
      set(value) {
        if (value === "notSpecified") {
          this.editedItem.openingHours.freeAccess = null;
          for (
            let i = 0;
            i < this.editedItem.openingHours.weekdays.length;
            i++
          ) {
            if (!this.editedItem.openingHours?.weekdays?.[i]) {
              this.editedItem.openingHours.weekdays[i] = {
                active: false,
                times: [{}],
                dayOfWeek: allWeekDays[i]
              };
            }
            this.editedItem.openingHours.weekdays[i].active = false;
          }
        } else this.editedItem.openingHours.freeAccess = value;
      }
    },
    selectableYears() {
      const currentYear = moment().year();
      return [currentYear, currentYear + 1, currentYear + 2];
    },
    holidays() {
      return this.$store.state.holidays;
    },
    vacations() {
      return this.$store.state.vacations;
    },
    stateItems() {
      return this?.sharedState?.stateItems || stateItems;
    },
    // closed weekdays of the current week (when available)
    // OR the week of the first opening hour in the future
    closedWeekDays() {
      let week = ["mo", "tu", "we", "th", "fr", "sa", "su"];
      const futureOpeningHours = this.editedItem?.calculatedOpeningHours?.filter(
        startAndEndTime => {
          return moment(startAndEndTime[0] * 1000).isAfter(
            moment().set({ hour: 0 })
          );
        }
      );
      if (!futureOpeningHours?.[0]?.[0]) {
        return "-";
      }
      const firstDayStartSecond = futureOpeningHours[0][0];
      const firstDay = moment(firstDayStartSecond * 1000); //to milliseconds-timestamp
      let rangeFrom = moment().set({ hour: 6 });
      let rangeTo = moment()
        .set({ hour: 23, minute: 59 })
        .add(7, "days");
      let notice = "Ruhetage: ";
      // if the first opening hour is more than 7 days in the future
      if (firstDay.isAfter(moment().add(7, "days"))) {
        notice = `Woche ab ${firstDay.format("DD.MM.YYYY")} Ruhetage: `;
        rangeFrom = firstDay.clone();
        rangeTo = firstDay
          .clone()
          .set({ hour: 23, minute: 59 })
          .add(7, "days");
      }

      futureOpeningHours.forEach(t => {
        // is in future but not more than 7 days apart
        if (!moment(t[0] * 1000).isBetween(rangeFrom, rangeTo)) {
          return;
        }
        const day = moment(t[0] * 1000, null, "en")
          .format("dd")
          .toLowerCase();
        //remove day from week
        week = week.filter(d => d !== day);
      });
      if (week.length === 0) {
        return "-";
      }
      // german translation
      const ruhetage = week.map(day =>
        day
          .replace("mo", "Mo")
          .replace("tu", "Di")
          .replace("we", "Mi")
          .replace("th", "Do")
          .replace("fr", "Fr")
          .replace("sa", "Sa")
          .replace("su", "So")
      );
      return notice + ruhetage.join(", ");
    }
  },
  inject: ["sharedState"]
};
